var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path8, _rect7, _g, _path9, _path10, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180 100C180 111.881 177.405 123.168 172.746 133.308C160.119 160.865 132.292 180 100 180C67.7081 180 39.8811 160.865 27.2541 133.308C22.5946 123.168 20 111.881 20 100C20 55.8162 55.8162 20 100 20C144.184 20 180 55.8162 180 100Z",
    fill: "#F4F7FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8001 133.1H123.6C119.127 133.1 115.5 129.474 115.5 125C115.5 120.527 119.127 116.9 123.6 116.9H43.5201C43.5134 116.9 43.5067 116.9 43.5 116.9H40.8C34.8353 116.9 30 121.736 30 127.7V133.1L40.8001 133.1Z",
    fill: "url(#paint0_linear_741_22108)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93 127.7C93 121.736 88.1647 116.9 82.2 116.9H42.6V143.9C42.6 149.865 47.4353 154.7 53.4 154.7H93V127.7Z",
    fill: "url(#paint1_linear_741_22108)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3999 54.8C62.3999 48.8353 67.2352 44 73.1999 44H143.4V135.8C143.4 146.238 134.938 154.7 124.5 154.7H62.3999V54.8Z",
    fill: "url(#paint2_linear_741_22108)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.4 65.6H70.5C76.4647 65.6 81.3 60.7647 81.3 54.8C81.3 48.8353 76.4647 44 70.5 44H143.4C149.365 44 154.2 48.8353 154.2 54.8C154.2 60.7647 149.365 65.6 143.4 65.6Z",
    fill: "url(#paint3_linear_741_22108)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.4001 144.799V154.699H52.5315C57.9847 154.682 62.4001 150.256 62.4001 144.799Z",
    fill: "#D4D8E1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0025 116.9L42.5999 116.9L42.5999 120.5C42.5999 118.513 40.9895 116.901 39.0025 116.9Z",
    fill: "#D0D4DE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 87.6001,
    y: 95.2988,
    width: 46.8,
    height: 7.2,
    rx: 2.7,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 95.2988,
    width: 7.2,
    height: 7.2,
    rx: 2.7,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 87.6001,
    y: 111.5,
    width: 36.9,
    height: 7.2,
    rx: 2.7,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 111.5,
    width: 7.2,
    height: 7.2,
    rx: 2.7,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 87.6001,
    y: 79.0996,
    width: 46.8,
    height: 7.2,
    rx: 2.7,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 79.0996,
    width: 7.2,
    height: 7.2,
    rx: 2.7,
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.819 97.3878C163.096 97.2049 162.658 96.4707 162.841 95.7479L163.504 93.1304C163.686 92.4076 164.421 91.9698 165.143 92.1527C165.866 92.3356 166.304 93.0698 166.121 93.7926L165.459 96.4101C165.276 97.1329 164.542 97.5706 163.819 97.3878ZM167.911 100.984C167.631 100.293 167.964 99.5056 168.655 99.2255L171.157 98.2111C171.848 97.931 172.635 98.264 172.915 98.955C173.195 99.646 172.862 100.433 172.171 100.713L169.669 101.728C168.978 102.008 168.191 101.675 167.911 100.984ZM169.048 106.152C168.327 105.961 167.588 106.392 167.398 107.112C167.207 107.833 167.637 108.572 168.358 108.762L170.969 109.452C171.69 109.642 172.428 109.212 172.619 108.491C172.809 107.77 172.379 107.031 171.658 106.841L169.048 106.152Z",
    fill: "#A1A5AC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 153.409,
    y: 132.686,
    width: 1.80469,
    height: 11.4449,
    transform: "rotate(-45 153.409 132.686)",
    stroke: "url(#paint4_linear_741_22108)",
    strokeWidth: 1.80469
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_741_22108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.73 139.643C154.324 138.237 154.324 135.958 155.73 134.552L156.553 133.728C157.959 132.322 160.239 132.322 161.645 133.728L174.569 146.653C175.975 148.059 175.975 150.338 174.569 151.744L173.746 152.568C172.34 153.974 170.06 153.974 168.654 152.568L155.73 139.643Z",
    fill: "url(#paint5_linear_741_22108)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M162.3 113.3C162.3 127.217 151.017 138.5 137.1 138.5C123.182 138.5 111.9 127.217 111.9 113.3C111.9 99.382 123.182 88.0996 137.1 88.0996C151.017 88.0996 162.3 99.382 162.3 113.3Z",
    fill: "#D9DCE0",
    fillOpacity: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.1 130.4C146.544 130.4 154.2 122.744 154.2 113.3C154.2 103.856 146.544 96.1996 137.1 96.1996C127.656 96.1996 120 103.856 120 113.3C120 122.744 127.656 130.4 137.1 130.4ZM137.1 138.5C151.017 138.5 162.3 127.217 162.3 113.3C162.3 99.382 151.017 88.0996 137.1 88.0996C123.182 88.0996 111.9 99.382 111.9 113.3C111.9 127.217 123.182 138.5 137.1 138.5Z",
    fill: "url(#paint6_linear_741_22108)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter1_f_741_22108)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 156.354,
    y1: 140.646,
    x2: 171.354,
    y2: 155.646,
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_741_22108",
    x: 153.775,
    y: 130.874,
    width: 21.8485,
    height: 22.7492,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.9,
    dy: -1.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.362969 0 0 0 0 0.386115 0 0 0 0 0.420833 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_741_22108"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_741_22108",
    x: 152,
    y: 136.293,
    width: 23.707,
    height: 23.707,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_741_22108"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_741_22108",
    x1: 74.3507,
    y1: 132.609,
    x2: 74.3681,
    y2: 117.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C5CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953081,
    stopColor: "#B1B4BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_741_22108",
    x1: 66.4811,
    y1: 153.554,
    x2: 66.6572,
    y2: 118.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8ADB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFD3DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_741_22108",
    x1: 105.02,
    y1: 151.342,
    x2: 104.746,
    y2: 76.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D7E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D5DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_741_22108",
    x1: 123.15,
    y1: 44,
    x2: 123.15,
    y2: 67.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.970777,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_741_22108",
    x1: 152.456,
    y1: 134.578,
    x2: 157.619,
    y2: 135.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0B8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#757982"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_741_22108",
    x1: 170.425,
    y1: 139.874,
    x2: 154.438,
    y2: 152.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBCED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C9D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_741_22108",
    x1: 116.4,
    y1: 95.2996,
    x2: 162.3,
    y2: 132.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9BEC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABB0B9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.4182b51ed8c5b89ff6d8c63f70ab044b.svg";
export { ForwardRef as ReactComponent };